{
  "title": "Loading & Dispatch",
  "subtitle": "Minimal dispatch record for packed/picked goods — the mobile app is the primary loading workflow.",
  "add": "New Loading Task",
  "confirm": "Confirm Loaded",
  "table": {
    "number": "Loading Task #",
    "dispatchOrders": "Dispatch Orders / Reference",
    "pickList": "Reference",
    "carrier": "Carrier",
    "vehicle": "Vehicle No",
    "invoiceNumber": "Invoice No",
    "ewayBillNo": "E-way Bill No",
    "status": "Status"
  },
  "form": {
    "carrier": "Carrier",
    "none": "None",
    "vehicleNo": "Vehicle No",
    "invoiceNumber": "Invoice Number",
    "ewayBillNo": "E-way Bill Number",
    "dispatchOrders": "Dispatch Orders",
    "dispatchOrdersHelper": "Only packing-completed dispatch orders with unloaded packages are shown — select one or more.",
    "dispatchOrdersHelperMaterialIssue": "Only dispatch orders with issued, not-yet-loaded material are shown — select one or more.",
    "packagesTitle": "Packages",
    "materialIssueTitle": "Issued Material",
    "selectDispatchOrdersFirst": "Select one or more dispatch orders above to see their packages.",
    "selectDispatchOrdersFirstMaterialIssue": "Select one or more dispatch orders above to see their issued material.",
    "noPackagesAvailable": "No unloaded packages remain for the selected dispatch order(s).",
    "noMaterialIssueLinesAvailable": "No unloaded material remains for the selected dispatch order(s).",
    "dispatchNo": "Dispatch No.",
    "packageNo": "Package No.",
    "materialCode": "Material Code",
    "materialName": "Material Name",
    "barcode": "Barcode",
    "qty": "Qty",
    "weight": "Weight",
    "selectedOf": "{{selected}} of {{total}} package(s) selected",
    "selectedOfLines": "{{selected}} of {{total}} line(s) selected",
    "scanBarcode": "Scan Barcode",
    "scanBarcodeHelperPackages": "Scan or type this package's barcode to add it to the load.",
    "scanBarcodeHelperLines": "Scan or type this line's barcode to add it to the load.",
    "scannedOfTotal": "{{scanned}} / {{total}}",
    "scanned": "Scanned",
    "noBarcodeBlocked": "Barcode Required is enabled in Process Configuration, but this row has no barcode or printed label — it can't be scanned onto the load. Assign a Material barcode or print a label first."
  },
  "partialConfirm": {
    "title": "Confirm partial loading",
    "message": "You've selected {{selected}} of {{total}} line(s). The rest will remain available to load later. Continue?",
    "confirm": "Continue"
  },
  "slip": {
    "title": "Dispatch Order Slip",
    "print": "Print Slip",
    "loadedDate": "Loaded Date",
    "dispatchOrders": "Dispatch Orders",
    "orderNo": "Order No.",
    "customer": "Customer",
    "items": "Items"
  },
  "save": "Save",
  "cancel": "Cancel"
}
